import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import {Button, Heading, Text} from '@albert-io/atomic';

import './marketing-banner.scss';

const MarketingBanner = ({buttonText, headingText, text, className, buttonProps}) => {
  return (
    <div
      className={classnames(
        'marketing-banner',
        className,
        'rounded-x1 border border-solid border-border-primary background-primary'
      )}
    >
      <div className='marketing-banner_text-block'>
        <Text className='marketing-banner_text-block--text' color='primary-inverse'>
          {text}
        </Text>
        <Heading color='primary-inverse' className='marketing-banner_text-block--heading mt-x1'>
          {headingText}
        </Heading>
        <Button {...buttonProps} className='marketing-banner_text-block--button mt-x3'>
          {buttonText}
        </Button>
      </div>
    </div>
  );
};

MarketingBanner.propTypes = {
  buttonText: PropTypes.string,
  headingText: PropTypes.string,
  text: PropTypes.string,
  className: PropTypes.string,
  buttonProps: PropTypes.object
};

export default MarketingBanner;
